import styled from 'styled-components';
import { lighten } from 'polished';

export const ButtonContainer = styled.button.attrs((props) => ({
  color: props.color,
  backgroundcolor: lighten(0.33, props.color),
}))`
  text-align: center;
  display: flex;
  align-items: center;
  background: ${(props) => props.color};
  margin: 5px 0 0;
  color: #fff;
  height: 36px;
  padding: 0 15px;
  font-weight: bold;
  border: 0;
  border-radius: 4px;
  font-size: 16px;
  transition: background 0.2s;

  svg {
    margin-right: 6px;
  }
`;
